// hooks/useVisitorRuns.js
import { useEffect, useState } from 'react';

const VISITOR_RUNS_KEY = 'pesacore_visitor_runs';
const MAX_FREE_RUNS = 2;   

export const useVisitorRuns = () => {
  const [runCount, setRunCount] = useState(0);
  const [hasReachedLimit, setHasReachedLimit] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(VISITOR_RUNS_KEY);
    const count = saved ? parseInt(saved, 10) : 0;
    setRunCount(count);
    setHasReachedLimit(count >= MAX_FREE_RUNS);
  }, []);

  const incrementRunVisitor = () => {
    const newCount = runCount + 1;
    localStorage.setItem(VISITOR_RUNS_KEY, newCount.toString());
    setRunCount(newCount);
    setHasReachedLimit(newCount >= MAX_FREE_RUNS);
    return newCount;
  };

  const resetRuns = () => {
    localStorage.removeItem(VISITOR_RUNS_KEY);
    setRunCount(0);
    setHasReachedLimit(false);
  };

  return {
    runCount,
    hasReachedLimit,
    incrementRunVisitor,
    resetRuns,
    maxFreeRuns: MAX_FREE_RUNS
  };
};